const getScreenWidth = () => Math.max(screen.width, screen.availWidth);

export default getScreenWidth;
